import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

export const fetchDamagesItems = createAsyncThunk(
  "damage/fetchDamagesItems",
  async ({
    warehouse_id,
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    state,
  }: {
    warehouse_id?: string;
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    state?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    // https://wmbe.dev.metaphi.in/project-warehouse/item-name/?item_name=Cement Bricks&make=C1&model=C1&page=1&page_size=10&qc_pass=fail&warehouse_id=
    const response: any = await WarehouseAxios.get(
      `/project-warehouse/damage/warehouse_id=${warehouse_id}&${params.toString()}`
    );
    // const response: any = await WarehouseAxios.get(
    //   `/project-warehouse/item-name/?item_name=${state?.item_name}&make=${state?.make}&model=${state?.model}/?${params.toString()}`
    // );

    return {
      data: response?.data.data || [],
     rowCount: response?.data?.count || 0,
    };
  }
);


export const exportDraftRFQCSV = async () => {
  const response = await WarehouseAxios.get(
    "/warehouse/dailyLogs/?export=csv",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};
